import { render, staticRenderFns } from "./StorageConfig.vue?vue&type=template&id=6a51edb4&scoped=true&"
import script from "./StorageConfig.vue?vue&type=script&lang=js&"
export * from "./StorageConfig.vue?vue&type=script&lang=js&"
import style0 from "./StorageConfig.vue?vue&type=style&index=0&id=6a51edb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a51edb4",
  null
  
)

export default component.exports